<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.drug', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form v-if="show">
                    <b-container>

                        <b-row>
                            <b-col col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.tradeName')"
                                        label-for="nom"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom_commercial.$model"
                                            :state="$v.form.nom_commercial.$dirty ? !(errorshasField('nom_commercial') || $v.form.nom_commercial.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom_commercial')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom_commercial.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('nom_commercial')">
                                        {{ getErrorsField('nom_commercial') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="principe_actif-group"
                                        :label="$t('message.activeSubstance')"
                                        label-for="principe_actif"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.principe_actif.$model"
                                            :state="$v.form.principe_actif.$dirty ? !(errorshasField('principe_actif') || $v.form.principe_actif.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('principe_actif')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.principe_actif.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('principe_actif')">
                                        {{ getErrorsField('principe_actif') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="classe_medicamenteuse-group"
                                        :label="$t('message.therapeuticClass')"
                                        label-for="classe_medicamenteuse"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.classe_medicamenteuse.$model"
                                            :state="$v.form.classe_medicamenteuse.$dirty ? !(errorshasField('classe_medicamenteuse') || $v.form.classe_medicamenteuse.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('classe_medicamenteuse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.classe_medicamenteuse.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('classe_medicamenteuse')">
                                        {{ getErrorsField('classe_medicamenteuse') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="forme_et_dosage-group"
                                        :label="$t('message.dosage')"
                                        label-for="forme_et_dosage"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.forme_et_dosage.$model"
                                            :state="$v.form.forme_et_dosage.$dirty ? !(errorshasField('forme_et_dosage') || $v.form.forme_et_dosage.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('forme_et_dosage')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.forme_et_dosage.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('forme_et_dosage')">
                                        {{ getErrorsField('forme_et_dosage') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="conditionement-group"
                                        :label="$t('message.packaging')"
                                        label-for="conditionement"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.conditionement.$model"
                                            :state="$v.form.conditionement.$dirty ? !(errorshasField('conditionement') || $v.form.conditionement.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('conditionement')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.conditionement.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('conditionement')">
                                        {{ getErrorsField('conditionement') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-container>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import { required, email, minLength,integer } from 'vuelidate/lib/validators';

    export default {
        name: "AddDrug",
        computed: {
            ...mapGetters(["errors", 'hasAdminRole',
                'hasGestionnaireRole', 'hasPraticienRole',]),

            can:function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole;
            }
        },

        data(){
            return {
                form:{
                    nom_commercial:"",
                    principe_actif:"",
                    classe_medicamenteuse:"",
                    forme_et_dosage:"",
                    conditionement:"",
                },

                show: true,
            }
        },

        methods:{
          onSubmit(evt){
              evt.preventDefault();

              this.$v.$touch();

              if(!this.$v.$invalid){
                  let args = {
                      nom_commercial:this.form.nom_commercial,
                      principe_actif:this.form.principe_actif,
                      classe_medicamenteuse:this.form.classe_medicamenteuse,
                      forme_et_dosage:this.form.forme_et_dosage,
                      conditionement:this.form.conditionement,
                  };
                  
                  let successMessage = this.$i18n.t('message.drugCreated');
                  let errorMessages = {
                      generic: this.$i18n.t('message.genericError'),
                      error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                  };

                  this.$store.dispatch('createDrug', { args, errorMessages, successMessage });
              }
          },
            
            onReset: function(evt) {
                evt.preventDefault();
          },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations() {
            return {
                form:{
                    nom_commercial:{required},
                    principe_actif:{required},
                    classe_medicamenteuse:{required},
                    forme_et_dosage:{required},
                    conditionement:{required},
                }, 
            }
        }
    }
</script>

<style scoped>

</style>